import { Heading, Picture } from '@petsmart-ui/sparky';
import cn from 'classnames';

import { cutText } from '../../utils/cutText';
import { propsImageItems } from '../../utils/propsImagesItems';
import type { CampaignHeroVariantProps } from './types';
import './CampaignHeroMd.scss';

export default function CampaignHeroMd({ header, image, primaryTextColor, isH1 }: Readonly<CampaignHeroVariantProps>) {
    const imageItems = propsImageItems(image);

    return (
        <div
            className={cn('campaign-hero-md', {
                'campaign-hero-md__grey': primaryTextColor === 'Dark Grey',
                'campaign-hero-md__red': primaryTextColor === 'Dark Grey w/ Red',
            })}
        >
            <Picture imgAlt={image.webAltText} imgSrc={imageItems[0]?.srcSet} items={imageItems} />

            <Heading tagName={isH1 ? 'h1' : 'h2'}>{cutText(header, 20)}</Heading>
        </div>
    );
}
